import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useGraphneAPI, ProductionPlanEntry } from '@nexelem/graphne-api';
import { GRAPHNE_TODO_LIST_KEY } from './useGraphneTodoList';
import { NodeType } from '../../components/organisms/ProductionPlans/Gantt/types';

export const useSaveGanttDropTaskMutation = () => {
  const api = useGraphneAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ type, taskId, ...productionPlanEntry }: ProductionPlanEntry & { type: NodeType }) => {
      if (type === NodeType.BATCH) {
        return api.postGraphneProductionPlanEntriesBatchMove({
          productionPlanBatchEntryView: {
            batchId: taskId,
            ...productionPlanEntry,
          },
        });
      }
      return api.postGraphneProductionPlanEntriesMove({
        productionPlanEntry: {
          ...productionPlanEntry,
          taskId,
        },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GRAPHNE_TODO_LIST_KEY] });
    },
  });
};
